import { ResourceName } from "../../../../../core/router/config/ResourceName";
import { baseAuthApi } from "../../../../../core/service/baseApi";
import type { FormMutation } from "../../../../../core/service/types/FormMutation";
import type { FormQuery } from "../../../../../core/service/types/FormQuery";
import type { Dto } from "../../../../../core/types/be/Dto";
import type { PosMappingEntity } from "../../types/PosMappingEntity";
import { PosMappingDtoToEntity } from "../mappers/PosMappingDtoToEntity";
import { PosMappingEntityToDto } from "../mappers/PosMappingEntityToDto";

const PosMappingApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        PosMappingLoad: builder.query<PosMappingEntity, FormQuery>({
            providesTags: [ResourceName.POS_MAPPINGS],
            query: (queryParams) => {
                return {
                    url: `${ResourceName.POS_MAPPINGS}/${queryParams.entityId}`,
                    method: "GET",
                };
            },
            transformResponse: (response: Dto, _) => {
                return PosMappingDtoToEntity(response);
            },
        }),
        PosMappingSave: builder.mutation<PosMappingEntity, FormMutation<PosMappingEntity>>({
            query: (mutation) => {
                const url = `${ResourceName.POS_MAPPINGS}`;
                const method = "POST";

                const body = PosMappingEntityToDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.POS_MAPPINGS],
        }),
        PosMappingUpdate: builder.mutation<PosMappingEntity, FormMutation<PosMappingEntity>>({
            query: (mutation) => {
                const url = `${ResourceName.POS_MAPPINGS}/${mutation.data.id}`;
                const method = "PUT";

                const body = PosMappingEntityToDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.POS_MAPPINGS],
        }),
    }),
});

export const { usePosMappingLoadQuery, usePosMappingSaveMutation, usePosMappingUpdateMutation } = PosMappingApi;
